




























































































































import BaseLoading from '@/components/base/BaseLoading.vue';
import {
  DeleteGroupLevelAttributeValuesDTO,
  InsertGroupLevelAttributeValueDTO,
  UpdateIndividualGroupLevelAttributeValueDTO
} from '@/jbi-shared/dto/jaas-group-level-attributes.dtos';
import { CourseDetails } from '@/jbi-shared/dto/jtms.dtos';
import { DateOrString } from '@/jbi-shared/types/full-document-revision-object.types';
import {
  AttributeOptionsWithValue,
  GroupLevelAttribute,
  GroupLevelAttributeListType,
  GroupLevelAttributeOption,
  GroupLevelAttributeValue,
  GroupLevelAttributeValueStatus,
  GroupLevelAttributeWithSpec
} from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';
import {
  clone,
  DEFAULT_COURSE_ATTRIBUTES,
  isDefaultCourseGLA,
  isTitleAttribute
} from '@/jbi-shared/util/group-level-attributes.util';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import BaseButton from '@/jbi-shared/vue-components/BaseButton.vue';
import {
  GroupLevelAttributeContactsType,
  GroupLevelAttributeType,
  InitialActiveDeletedAttributes
} from '@/store/modules/admin/types/group-level-attribute.types';
import { MasterGroupsResponseDTO } from '@/store/modules/admin/types/group.types';
import { CourseTypeOption } from '@/store/modules/jtms/course/course.types';
import { EntityTypes } from '@/store/modules/module-tree/enums/module-tree.enums';
import {
  PermissionsMatrixActionsEnum,
  ResourceExceptions
} from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';
import { RootState } from '@/store/store';
import { ApiAxiosError, ApiState } from '@/store/types/general.types';
import {
  convertToAttributeOptionsWithValue,
  transformGroupLevelAttributePayload
} from '@/utils/group-level-attribute.util';
import { generateTempId } from '@/utils/jtms-utils';
import { isUserAllowed } from '@/utils/rbac.util';
import EditAttributeModal from '@/views/AdminGroupManagement/components/EditAttributeModal.vue';
import CreateNewGroupLevelAttributeModal from '@/views/AdminGroupSettings/components/GroupLevelAttributes/CreateNewGroupLevelAttributeModal.vue';
import FieldWrapper from '@/views/AdminGroupSettings/components/GroupLevelAttributes/FieldWrapper.vue';
import GroupLevelAttributeAddressField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeAddressField.vue';
import GroupLevelAttributeAdministratorFeeField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeAdministratorFeeField.vue';
import GroupLevelAttributeBooleanField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeBooleanField.vue';
import GroupLevelAttributeContactField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeContactField.vue';
import GroupLevelAttributeCoordinatesField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeCoordinatesField.vue';
import GroupLevelAttributeDateField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeDateField.vue';
import GroupLevelAttributeDatetimeField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeDateTimeField.vue';
import GroupLevelAttributeEmailField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeEmailField.vue';
import GroupLevelAttributeLinkField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeLinkField.vue';
import GroupLevelAttributeListField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeListField.vue';
import GroupLevelAttributeLocationField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeLocationField.vue';
import GroupLevelAttributeNumberField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeNumberField.vue';
import GroupLevelAttributeOrganisationField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeOrganisationField.vue';
import GroupLevelAttributePhoneField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributePhoneField.vue';
import GroupLevelAttributeTextArea from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeTextArea.vue';
import GroupLevelAttributeTextField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeTextField.vue';
import GroupLevelAttributeTimezoneField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeTimezoneField.vue';
import GroupLevelAttributeTrainerField from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeTrainerField.vue';
import GroupLevelAttributeUploadable from '@/views/AdminGroupSettings/components/GroupLevelAttributes/GroupLevelAttributeUploadable.vue';
import ExistingGroupLevelAttributesModal from '@/views/components/PaginatedGroupLevelAttributes/ExistingGroupLevelAttributesModal.vue';
import { ToastProgrammatic as Toast } from 'buefy';
import dayjs from 'dayjs';
import {
  Component,
  Emit,
  Prop,
  PropSync,
  Vue,
  Watch
} from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { Action, State } from 'vuex-class';
import { debounce } from '@/jbi-shared/util/debounce.util';
import { deepEqual, deepCopy } from '@/jbi-shared/util/deep-copy.util';
import CourseTitleAttributeField from './DefaultAttributes/CourseTitleAttributeField.vue';

@Component({
  computed: {
    PermissionsMatrixActionsEnum() {
      return PermissionsMatrixActionsEnum;
    }
  },
  components: {
    draggable,
    BaseLoading,
    FieldWrapper,
    BaseButton
  }
})
export default class CourseLevelAttributeTab extends Vue {
  @PropSync('courseName') syncedCourseTitle!: string;
  @PropSync('courseType') syncedCourseType!: CourseTypeOption;
  @Prop() isSettings!: boolean;
  @Prop() disableModulesTab!: boolean;
  @Prop({ default: false }) shouldDisableAttributes!: boolean;
  @Prop() groupId!: number;
  @Prop() isCourseLevelAttributeTabOpened!: boolean;
  @Prop() groupTypeName!: string;
  @Prop() groupExceptions!: ResourceExceptions;

  textType: GroupLevelAttributeType | null = null;
  textAreaType: GroupLevelAttributeType | null = null;
  datetimeType: GroupLevelAttributeType | null = null;
  timezoneType: GroupLevelAttributeType | null = null;
  organisationType: GroupLevelAttributeType | null = null;
  trainerType: GroupLevelAttributeType | null = null;
  locationType: GroupLevelAttributeType | null = null;
  contactsType: GroupLevelAttributeType | null = null;

  availableAttributeTypes: GroupLevelAttributeType[] = [];
  defaultCourseLevelAttributes: GroupLevelAttributeValue[] = [];
  activeNonDefaultCourseLevelAttributes: GroupLevelAttributeValue[] = [];
  selectedCourseAttributeValues: GroupLevelAttributeValue[] = [];
  updateAttributeDebouncers: Record<number, any> = {};

  draggableComponentKey: number = generateTempId() * -1; // Convert to positive integer

  isInitializing: boolean = true;
  areDefaultAttributesMassaged: boolean = false;
  areGroupLevelAttributeValuesMassaged: boolean = false;
  hasFetchedDefaultValues: boolean = false;
  hasTrainersInGLAs: boolean = false;

  selectedTrainerIds: number[] = [];
  parentGroup: MasterGroupsResponseDTO | null = null;
  minDate: DateOrString | null = null;
  maxDate: DateOrString | null = null;

  /**
   * Actions and States: Group Level Attribute Types
   */
  @Action('admin/getGroupLevelAttributeTypes')
  getGroupLevelAttributeTypes!: () => void;

  @State(({ admin }: RootState) => admin.apiState.getGroupLevelAttributeTypes)
  getGroupLevelAttributeTypesApiState!: ApiState;

  @State((state: RootState) => state.admin.groupLevelAttributeTypes)
  groupLevelAttributeTypes!: GroupLevelAttributeType[];

  /**
   * Actions and States: Default Course Level Attributes
   */
  @Action('course/getDefaultCourseLevelAttributes')
  getDefaultCourseLevelAttributes!: () => void;

  @State(
    ({ course }: RootState) => course.apiState.getDefaultCourseLevelAttributes
  )
  getDefaultCourseLevelAttributesApiState!: ApiState;

  @State(({ course }: RootState) => course.defaultCourseLevelAttributes)
  defaultCourseGLAs!: GroupLevelAttribute[];

  @State((state: RootState) => state.course.courseDetails)
  public courseDetails!: CourseDetails;

  /**
   * Actions and States: Required Public Course Level Attributes
   */
  @Action('course/getRequiredPublicCourseLevelAttributes')
  getRequiredPublicCourseLevelAttributes!: () => void;

  @State(
    ({ course }: RootState) =>
      course.apiState.getRequiredPublicCourseLevelAttributes
  )
  getRequiredPublicCourseLevelAttributesApiState!: ApiState;

  @State(({ course }: RootState) => course.requiredPublicCourseLevelAttributes)
  requiredPublicCourseLevelAttributes!: GroupLevelAttribute[];

  /**
   * Actions and States: Group Level Attribute Values
   */
  @Action('admin/deleteGroupLevelAttributeValues')
  deleteGroupLevelAttributeValues!: (
    payload: DeleteGroupLevelAttributeValuesDTO
  ) => Promise<void>;

  @State(
    (state: RootState) => state.admin.apiState.deleteGroupLevelAttributeValues
  )
  deleteGroupLevelAttributeValuesApiState!: ApiState;

  @Action('admin/createGroupLevelAttributeValues')
  createGroupLevelAttributeValues!: (
    payload: InsertGroupLevelAttributeValueDTO
  ) => Promise<void>;

  @State(
    (state: RootState) => state.admin.apiState.createGroupLevelAttributeValues
  )
  createGroupLevelAttributeValuesApiState!: ApiState;

  @Action('admin/getGroupLevelAttributeValuesByGroupId')
  getGroupLevelAttributeValuesByGroupId!: (groupId: number) => void;

  @Action('admin/upsertIndividualGroupLevelAttributeValue')
  upsertIndividualGroupLevelAttributeValue!: (
    payload: UpdateIndividualGroupLevelAttributeValueDTO
  ) => Promise<void>;

  @Action('coursePackage/validateAllCoursePackages')
  validateAllCoursePackages!: () => void;

  @Action('courseModule/validateAllCourseModules')
  validateAllCourseModules!: () => void;

  @State(
    (state: RootState) =>
      state.admin.apiState.upsertIndividualGroupLevelAttributeValue
  )
  upsertIndividualGroupLevelAttributeValueApiState!: ApiState;

  @State((state: RootState) => state.admin.updatedGroupLevelAttributeValue)
  updatedGroupLevelAttributeValue!: AttributeOptionsWithValue;

  @State((state: RootState) => state.admin.createdGroupLevelAttributeValues)
  createdGroupLevelAttributeValues!: AttributeOptionsWithValue[];

  @State((state: RootState) => state.admin.groupLevelAttributeValuesByGroupId)
  currentGroupAttributeValues!: GroupLevelAttributeValue[];

  @State(
    (state: RootState) =>
      state.admin.newGroupLevelAttribute?.createdGroupLevelAttribute
  )
  createdGroupLevelAttribute!: GroupLevelAttribute;

  @State(
    ({ admin }: RootState) =>
      admin.apiState.getGroupLevelAttributeValuesByGroupId
  )
  getGroupLevelAttributeValuesByGroupIdApiState!: ApiState;

  @State((state: RootState) => state.admin.apiState.createGroupLevelAttribute)
  createGroupLevelAttributeApiState!: ApiState;

  @State((state: RootState) => state.course.courseCreationState.hasModules)
  hasModules!: boolean;

  @State(
    ({ admin }: RootState) => admin.apiState.getGroupLevelAttributeTypes.success
  )
  public getGroupLevelAttributeTypesSuccess!: ApiState;

  @State(
    ({ course }: RootState) =>
      course.courseLevelAttributeState.locationGLAConfig
  )
  existingLocationGLAConfig!: GroupLevelAttributeOption[];

  get PermissionsMatrixActionsEnum() {
    return PermissionsMatrixActionsEnum;
  }

  get shouldWaitForGLAValues() {
    return this.isSettings && !this.areGroupLevelAttributeValuesMassaged;
  }

  get trainerGLAConfig() {
    return DEFAULT_COURSE_ATTRIBUTES.TRAINER;
  }

  public isUserAllowed(
    action: PermissionsMatrixActionsEnum,
    module: string,
    skipImplicitCheck?: boolean
  ): boolean {
    const instance = EntityTypes.GROUP + '_' + this.groupId;
    return this.isSettings
      ? isUserAllowed(
          action,
          module,
          EntityTypes.GROUP,
          this.groupTypeName,
          this.groupId,
          this.groupExceptions,
          skipImplicitCheck
        )
      : true;
  }

  created() {
    /**
     * Attribute types are fetched on component mount
     * because text, text area, and date types are needed
     * to create default attributes
     */
    this.getGroupLevelAttributeTypes();

    // Reset initialization flag
    this.isInitializing = true;
  }

  mounted() {
    this.validateAllCourseModules();
    this.validateAllCoursePackages();
  }

  @Debounce(1500)
  debouncedCreateGroupLevelAttributeValues(
    attributesToInsert: GroupLevelAttributeValue[]
  ) {
    this.createGroupLevelAttributeValues(
      this.constructCreatePayload(attributesToInsert)
    );
  }

  debouncedUpdateGroupLevelAttributeValues(
    attributeToUpdate: AttributeOptionsWithValue
  ) {
    const attributeId = attributeToUpdate.groupLevelAttributeId;

    if (!this.updateAttributeDebouncers[attributeId]) {
      this.updateAttributeDebouncers[attributeId] = debounce(
        (attribute: AttributeOptionsWithValue) => {
          this.upsertIndividualGroupLevelAttributeValue(
            this.constructUpsertPayload(attribute)
          );
        },
        1500
      );
    }

    this.updateAttributeDebouncers[attributeId](attributeToUpdate);
  }

  @Debounce(1500)
  debouncedDeleteGroupLevelAttributeValues(
    attributeToDelete: GroupLevelAttributeValue[]
  ) {
    this.deleteGroupLevelAttributeValues(
      this.constructDeletePayload(attributeToDelete)
    );
  }

  constructUpsertPayload(attributeToUpdate: AttributeOptionsWithValue) {
    const upsertGroupLevelAttributeValuePayload: UpdateIndividualGroupLevelAttributeValueDTO = {
      groupId: this.groupId,
      attribute: attributeToUpdate
    };
    return upsertGroupLevelAttributeValuePayload;
  }

  constructDeletePayload(attributesToDelete: GroupLevelAttributeValue[]) {
    const convertedAttributesToDelete: AttributeOptionsWithValue[] = convertToAttributeOptionsWithValue(
      attributesToDelete
    );

    const deleteGroupLevelAttributeValuePayload: DeleteGroupLevelAttributeValuesDTO = {
      groupId: this.groupId,
      deleted: convertedAttributesToDelete
    };

    return deleteGroupLevelAttributeValuePayload;
  }

  constructCreatePayload(attributesToCreate: GroupLevelAttributeValue[]) {
    const currentActiveAttributesArrayLength: number = [
      ...this.defaultCourseLevelAttributes,
      ...this.activeNonDefaultCourseLevelAttributes
    ].length;

    const convertedAttributesToCreate: AttributeOptionsWithValue[] = convertToAttributeOptionsWithValue(
      attributesToCreate
    );
    const reorderedArray: AttributeOptionsWithValue[] = convertedAttributesToCreate.map(
      (attr, index) => {
        return {
          ...attr,
          order: index + 1 + currentActiveAttributesArrayLength
        };
      }
    );

    const createGroupLevelAttributeValuePayload: InsertGroupLevelAttributeValueDTO = {
      groupId: this.groupId,
      attributeValues: reorderedArray
    };

    return createGroupLevelAttributeValuePayload;
  }

  // Return field component for dynamic rendering of active attributes.
  getDynamicFieldComponent(attrVal: GroupLevelAttributeValue) {
    if (attrVal.isTitle) {
      return CourseTitleAttributeField;
    }
    switch (attrVal.groupLevelAttributeType.type) {
      case 'link':
        return GroupLevelAttributeLinkField;
      case 'text area':
        return GroupLevelAttributeTextArea;
      case 'email':
        return GroupLevelAttributeEmailField;
      case 'address':
        return GroupLevelAttributeAddressField;
      case 'integer':
        return GroupLevelAttributeNumberField;
      case 'boolean':
        return GroupLevelAttributeBooleanField;
      case 'list':
        return GroupLevelAttributeListField;
      case 'images':
      case 'documents':
        return GroupLevelAttributeUploadable;
      case 'coordinates':
        return GroupLevelAttributeCoordinatesField;
      case 'phone':
        return GroupLevelAttributePhoneField;
      case 'date':
        return GroupLevelAttributeDateField;
      case 'datetime':
        return GroupLevelAttributeDatetimeField;
      case 'administration fee':
        return GroupLevelAttributeAdministratorFeeField;
      case 'timezone':
        return GroupLevelAttributeTimezoneField;
      case 'organisation':
        return GroupLevelAttributeOrganisationField;
      case 'trainer':
        return GroupLevelAttributeTrainerField;
      case 'location':
        return GroupLevelAttributeLocationField;
      case 'contact':
        return GroupLevelAttributeContactField;
      default:
        return GroupLevelAttributeTextField;
    }
  }

  /* Set attribute value for deletion */
  markAttributeForDeletion(attributeValue: GroupLevelAttributeValue) {
    attributeValue.groupLevelAttributeSpec.order = 0;
    attributeValue.mapStatus = GroupLevelAttributeValueStatus.DELETE;
    attributeValue.hasFieldError = false;
    attributeValue.hasDuplicationError = false;
  }

  /*
   * Update ordering of active attributes, then emit value.
   * Ordering should increment from default attributes.
   */
  updateOrderingAndParentValue() {
    this.activeNonDefaultCourseLevelAttributes.forEach((attribute, index) => {
      attribute.groupLevelAttributeSpec.order =
        index + 1 + this.defaultCourseLevelAttributes.length;
    });

    this.updateParentValue();
  }

  /*
   * Update attribute value for deletion
   * and move attribute to delete array.
   */
  handleDeleteAttribute(attributeIndex: number) {
    const attributeToDelete: GroupLevelAttributeValue = this
      .activeNonDefaultCourseLevelAttributes[attributeIndex];

    if (
      attributeToDelete.id &&
      this.updateAttributeDebouncers[attributeToDelete.id]
    ) {
      if (
        typeof this.updateAttributeDebouncers[attributeToDelete.id].cancel ===
        'function'
      ) {
        this.updateAttributeDebouncers[attributeToDelete.id].cancel();
      }
      delete this.updateAttributeDebouncers[attributeToDelete.id];
    }

    this.markAttributeForDeletion(attributeToDelete);
    this.debouncedDeleteGroupLevelAttributeValues([attributeToDelete]);
    this.activeNonDefaultCourseLevelAttributes.splice(attributeIndex, 1);
  }

  beforeDestroy() {
    Object.values(this.updateAttributeDebouncers).forEach((debouncer) => {
      if (debouncer && typeof debouncer.cancel === 'function') {
        debouncer.cancel();
      }
    });
    this.updateAttributeDebouncers = {};
  }

  /*
   * Attribute to update could be in active or default array.
   * Locate attribute before emitting to parent.
   */
  handleUpdateAttributeValue(updatedAttribute: GroupLevelAttributeValue) {
    const contactsConfigs = DEFAULT_COURSE_ATTRIBUTES.CONTACT;

    const isContactGLA =
      updatedAttribute.label.toLowerCase() === contactsConfigs.label &&
      updatedAttribute.groupLevelAttributeType.type === contactsConfigs.type;

    const targetArray = updatedAttribute.groupLevelAttributeSpec.isDefault
      ? this.defaultCourseLevelAttributes
      : this.activeNonDefaultCourseLevelAttributes;

    const attributeIndex: number = targetArray.findIndex(
      (attribute) => attribute.id === updatedAttribute.id
    );

    // If there are no current values, skip validation
    if (!this.currentGroupAttributeValues) {
      return;
    }

    const currentAttributeFromDatabase = this.currentGroupAttributeValues.find(
      (attr) => Number(attr.id) === updatedAttribute.id
    );

    if (attributeIndex !== -1) {
      const existingAttribute = targetArray[attributeIndex];

      if (isContactGLA) {
        updatedAttribute.value = this.minimizeContactValues(
          updatedAttribute.value as GroupLevelAttributeContactsType[]
        );
      }

      if (!this.isInitializing) {
        if (!currentAttributeFromDatabase) {
          return;
        }

        // Check if the value has actually changed to prevent unnecessary saves
        if (
          !deepEqual(
            currentAttributeFromDatabase!.value,
            updatedAttribute.value
          )
        ) {
          targetArray.splice(attributeIndex, 1, existingAttribute);

          existingAttribute.value = updatedAttribute.value;
          const convertedAttribute = convertToAttributeOptionsWithValue([
            existingAttribute
          ])[0];
          this.debouncedUpdateGroupLevelAttributeValues(convertedAttribute);
        }
      } else {
        existingAttribute.value = updatedAttribute.value;
        targetArray.splice(attributeIndex, 1, existingAttribute);
      }
      this.updateParentValue();
    }
  }

  /**
   * In order to handle deeply nested field-level input validation,
   * an error message object is appended during object initialisation.
   * This method is specific for removing error message property
   * from contact GLA type before persisting the values into database.
   */
  minimizeContactValues(contactGLAValues: GroupLevelAttributeContactsType[]) {
    return contactGLAValues.map((contactGLAValue) => {
      const {
        errorMessage,
        hasFieldError,
        ...minimizedContactGLAValue
      } = contactGLAValue;
      return minimizedContactGLAValue;
    });
  }

  updateParentValue() {
    this.$emit(
      'updateValuesAndError',
      [
        ...this.defaultCourseLevelAttributes,
        ...this.activeNonDefaultCourseLevelAttributes
      ],
      this.getGroupLevelAttributeError()
    );
  }

  /**
   * This method is used to assign selected primary group to parentGroup variable.
   * The value is emitted from child component, which will be emitted upwards to the
   * `CreateCoursePage` component (used to construct course creation payload)
   */
  assignPrimaryOrganisationAsParentGroup(data: MasterGroupsResponseDTO) {
    this.parentGroup = data;
    this.returnParentGroup();
  }

  /**
   * This method is used to assign selected trainers to selectedTrainerId variable.
   * The value is emitted from child component, which will be emitted upwards to the
   * `CreateCoursePage` component (used to construct course creation payload)
   */
  assignSelectedTrainerIds(data: number[]) {
    this.selectedTrainerIds = data;
    this.returnSelectedTrainerIds();
  }

  /**
   * The following methods `assignStartDateValue` and `assignEndDateValue`
   * are used update the `startDate` and `endDate` props being conditionally
   * passed into the `FieldWrapper` component, which itself is rendered
   * dynamically.
   *
   * The child component (`GroupLevelAttributeDateField`) will conditionally
   * emit either the start or end date based on which prop is passed in:
   *
   * 1. In START DATE:
   *    - `endDate` prop is passed in to child component with 'Start Date' label.
   *    - Date value is updated, trigger `assignEndDate` with event to update
   *      `startDate` prop in **parent** component
   *    - In child component, if `endDate` prop _is null_, no `max-date` for `b-datepicker`.
   *        - No maximum date restriction
   *    - In child component, if `endDate` prop _is not null_, assign prop to
   *      `max-date` for `b-datepicker`.
   *        - Restricts the _latest_ date to `endDate`
   * 2. In END DATE:
   *    - `startDate` prop is passed in to child component with 'End Date' label.
   *    - Date value is updated, trigger `assignEndDate` with event to update
   *      `startDate` prop in **parent** component
   *    - In child component, if `startDate` prop _is null_, no `min-date` for `b-datepicker`.
   *        - No minimum date restriction
   *    - In child component, if `startDate` prop _is not null_, assign prop to
   *      `min-date` for `b-datepicker`.
   *        - Restricts the _earliest_ date to `startDate`
   *
   * With these loop of events, the start and end dates can be assigned logically.
   */
  assignStartDateValue(date: DateOrString) {
    this.minDate = date;
  }

  assignEndDateValue(date: DateOrString) {
    this.maxDate = date;
  }

  openAddExistingAttributesModal(): void {
    this.$buefy.modal.open({
      parent: this,
      component: ExistingGroupLevelAttributesModal,
      hasModalCard: true,
      trapFocus: true,
      canCancel: false,
      fullScreen: true,
      props: {
        selectedAttributes: this.activeNonDefaultCourseLevelAttributes,
        // Pass in emtpy array to prevent modifying props of existing component
        deletedAttributes: [],
        isCourseCreation: true
      },
      events: {
        updateSelection: (
          updatedAttributesPayload: InitialActiveDeletedAttributes
        ) => {
          this.activeNonDefaultCourseLevelAttributes = [
            ...updatedAttributesPayload.initial,
            ...transformGroupLevelAttributePayload(
              updatedAttributesPayload.active
            )
          ];

          if (updatedAttributesPayload.active.length !== 0) {
            // Only call `createGroupLevelAttributeValues` to create payload on ACTIVE, UNMAPPED attributes.
            // All initial attributes should already contain mappings.
            const nonMappedActiveAttributesWithSpec: GroupLevelAttributeWithSpec[] = updatedAttributesPayload.active.filter(
              (attr) => !attr.mapId
            );

            this.debouncedCreateGroupLevelAttributeValues(
              transformGroupLevelAttributePayload(
                nonMappedActiveAttributesWithSpec
              )
            );
          }

          if (updatedAttributesPayload.deleted.length !== 0) {
            this.debouncedDeleteGroupLevelAttributeValues(
              transformGroupLevelAttributePayload(
                updatedAttributesPayload.deleted
              )
            );
          }

          this.updateOrderingAndParentValue();
        }
      }
    });
  }

  openAddGroupLevelAttributeModal() {
    this.$buefy.modal.open({
      parent: this,
      component: CreateNewGroupLevelAttributeModal,
      hasModalCard: true, // added to prevent breaking on mobile
      trapFocus: true,
      fullScreen: false,
      canCancel: true,
      props: {
        allAttributeTypes: this.availableAttributeTypes, // clone types to avoid directly mutating state
        isCourseContext: true
      },
      events: {
        addNewAttribute: (attributeValue: GroupLevelAttributeWithSpec) => {
          const currentActiveAttributesArrayLength: number = [
            ...this.defaultCourseLevelAttributes,
            ...this.activeNonDefaultCourseLevelAttributes
          ].length;

          const modifiedPayload: GroupLevelAttributeValue = {
            ...attributeValue,
            groupLevelAttributeSpec: {
              order: currentActiveAttributesArrayLength + 1,
              isRequired: attributeValue.groupLevelAttributeSpec.isRequired
            },
            value: attributeValue.option,
            hasFieldError: false,
            hasDuplicationError: false,
            isDisabled: false
          };

          this.debouncedCreateGroupLevelAttributeValues([modifiedPayload]);

          this.activeNonDefaultCourseLevelAttributes.push(modifiedPayload);
          this.updateOrderingAndParentValue();
        }
      }
    });
  }

  openEditAttributeModal(
    attributeToEdit: GroupLevelAttributeValue,
    index: number
  ): void {
    this.$buefy.modal.open({
      parent: this,
      component: EditAttributeModal,
      hasModalCard: true,
      trapFocus: true,
      fullScreen: false,
      canCancel: true,
      props: {
        attributeId: Number(attributeToEdit.id)
      },
      events: {
        attributeUpdateSuccess: (
          updatedAttribute: GroupLevelAttribute
        ): void => {
          /**
           * Special update procedure for address-type Group Level Attributes. Updates status of
           * building name (index 0) and address line two (index 2) components based on edited values.
           * If a component is marked for deletion (status='DELETE'), its value is reset to empty string
           * to ensure proper rendering in the UI.
           */
          if (updatedAttribute.groupLevelAttributeType.type === 'address') {
            // Map between known positions for address components ([0] is building name and [2] is address line two)
            const addressLineMap = [0, 2];

            addressLineMap.forEach((position) => {
              const updatedOption = (updatedAttribute.option as GroupLevelAttributeOption[])[
                position
              ];
              const currentValue = (attributeToEdit.value as GroupLevelAttributeOption[])[
                position
              ];

              currentValue.status = updatedOption.status;

              if (updatedOption.status === 'DELETE') {
                currentValue.value = '';
              }
            });
          }

          // Custom checking logic for lists
          if (updatedAttribute.groupLevelAttributeType.type === 'list') {
            const updatedOption = updatedAttribute.option as GroupLevelAttributeListType;
            const currentValue = attributeToEdit.value as GroupLevelAttributeListType;

            // Only perform `selected` transformation if there was a change in selection type
            if (
              currentValue.isSingleSelection !== updatedOption.isSingleSelection
            ) {
              currentValue.isSingleSelection = updatedOption.isSingleSelection;

              if (!updatedOption.isSingleSelection) {
                // Single select -> Multi select, reassign selected values into an array containing itself
                currentValue.selected = [currentValue.selected as string];
              } else {
                // Multi select -> Single select, default to first item in multi select array
                currentValue.selected = (currentValue.selected as string[])[0];
              }
            }
          }

          /**
           * Immutable approach for updating local arrary (create new template) to ensure changes
           * to attributes are reflected. This approach ensures Vue detects the change.
           *
           * For small arrays (dozens of items), the performance impact would be negligible.
           */
          const updatedItem = {
            ...this.activeNonDefaultCourseLevelAttributes[index],
            label: updatedAttribute.label,
            option: updatedAttribute.option,
            value: attributeToEdit.value
          };

          // Use splice to replace the item at index
          this.activeNonDefaultCourseLevelAttributes.splice(
            index,
            1,
            updatedItem
          );
        }
      }
    });
  }

  clearAddressLineValue(
    attributeToEdit: GroupLevelAttributeValue,
    index: number
  ) {
    (attributeToEdit.value as GroupLevelAttributeOption[])[index].value = '';
  }

  /*
   * This method checks for the three possible errors in each field.
   * (ie label error, value error, duplication error)
   *
   * Note: DO NOT convert this method into a getter.
   * Getter gives inaccurate result.
   */
  getGroupLevelAttributeError(): boolean {
    const allAttributes: GroupLevelAttributeValue[] = [
      ...this.defaultCourseLevelAttributes,
      ...this.activeNonDefaultCourseLevelAttributes
    ];

    if (allAttributes.length) {
      const labelError: boolean = allAttributes.some(
        (attrVal) => attrVal.label === ''
      );

      const valueError: boolean = allAttributes.some(
        (attrVal) => attrVal.hasFieldError
      );

      const duplicationError: boolean = allAttributes.some(
        (attrVal) => attrVal.hasDuplicationError
      );

      // TODO: Add course template name validation
      // Course templates are still WIP from client
      if (!labelError && !valueError && !duplicationError) {
        return false;
      }
      return labelError || valueError || duplicationError;
    }
    return false;
  }

  // Update ordering value
  updateDefaultGLAOrdering() {
    this.defaultCourseLevelAttributes.forEach((attr, index) => {
      attr.groupLevelAttributeSpec.order = index + 1;
    });
  }

  /**
   * Restores the default "Trainers" Group Level Attribute (GLA) to the active list.
   *
   * It retrieves the original "Trainers" GLA data from the master `defaultCourseGLAs`
   * state, transforms it into the correct component format, and then re-inserts it into
   * the `defaultCourseLevelAttributes` list at its original position. It also calls
   * the `debouncedCreateGroupLevelAttributeValues` to persist changes in database.
   */
  restoreTrainersGLA() {
    const trainerGLAIndex = this.getTrainerGLAIndexFromDefaultGLAs();
    const transformedTrainerGLA = transformGroupLevelAttributePayload(
      [this.defaultCourseGLAs[trainerGLAIndex]],
      true
    )[0];

    if (trainerGLAIndex !== -1) {
      this.defaultCourseLevelAttributes.splice(
        trainerGLAIndex,
        0,
        transformedTrainerGLA
      );

      this.updateDefaultGLAOrdering();
      this.debouncedCreateGroupLevelAttributeValues([transformedTrainerGLA]);
    }
  }

  /**
   * Removes the default "Trainers" Group Level Attribute (GLA) from the list.
   *
   * The GLA is not just removed from the active list but is also marked for deletion
   * in the backend. It finds the "Trainers" GLA, sets its status properties
   * (mapStatus, attributeStatus) to DELETE, moves it to the `deleteCourseLevelAttributes`
   * array for persistence, and then removes it from the `defaultCourseLevelAttributes` list.
   *
   * After removal, the ordering of the remaining default GLAs is updated.
   */
  removeTrainersGLA(triggerAPI: boolean = true) {
    const existingTrainerIndexInActiveDefaultGLAs: number = this.defaultCourseLevelAttributes.findIndex(
      (gla) =>
        gla.groupLevelAttributeType.type === this.trainerGLAConfig.type &&
        gla.label.toLowerCase() === this.trainerGLAConfig.label
    );

    if (existingTrainerIndexInActiveDefaultGLAs !== -1) {
      const existingTrainerGLA: GroupLevelAttributeValue = this
        .defaultCourseLevelAttributes[existingTrainerIndexInActiveDefaultGLAs];

      this.markAttributeForDeletion(existingTrainerGLA);

      this.defaultCourseLevelAttributes.splice(
        existingTrainerIndexInActiveDefaultGLAs,
        1
      );

      if (triggerAPI) {
        this.debouncedDeleteGroupLevelAttributeValues([existingTrainerGLA]);
      }

      this.updateDefaultGLAOrdering();
    }
    return;
  }

  shouldHideGLA(gla: GroupLevelAttributeValue): boolean {
    return (
      (gla.label.toLocaleLowerCase() === 'course type' ||
        gla.label.toLocaleLowerCase() === 'status') &&
      gla.groupLevelAttributeType.type === 'list'
    );
  }

  getTrainerGLAIndexFromDefaultGLAs() {
    return this.defaultCourseGLAs.findIndex(
      (attrVal) =>
        attrVal.groupLevelAttributeType.type === this.trainerGLAConfig.type &&
        attrVal.label.toLowerCase() === this.trainerGLAConfig.label
    );
  }

  /**
   * Disable (hide) course type and status from frontend.
   * The reason for the duplicate reference in GLAs is just for consistency; at some point,
   * JTMS Course details will be displayed in the frontend via public API, and the GLAs will
   * reflect the properties/fields of the return object (JSON).
   *
   * These GLA values will still be updated based on course creation from the payload level.
   * User will not be aware of the selections.
   */
  processDefaultCourseLevelAttributes(): GroupLevelAttributeValue[] {
    this.defaultCourseLevelAttributes = transformGroupLevelAttributePayload(
      this.defaultCourseGLAs,
      true,
      this.shouldDisableAttributes
    );

    if (this.isSettings && this.hasModules) {
      this.removeTrainersGLA(false);
    }

    return this.defaultCourseLevelAttributes.map((defaultGLA) => {
      if (this.shouldHideGLA(defaultGLA)) {
        return {
          ...defaultGLA,
          // The `isHidden` flag will be used to determine if a GLA should be hidden.
          isHidden: true,
          // The `isDisabled` flag will be used to disabled/enable GLA input fields.
          isDisabled: true,
          groupLevelAttributeSpec: {
            ...defaultGLA.groupLevelAttributeSpec,
            isRequired: false // Hidden GLAs are not required
          }
        };
      }

      if (
        this.isSettings &&
        this.existingLocationGLAConfig.length > 0 &&
        defaultGLA.label === 'Location' &&
        defaultGLA.groupLevelAttributeType.type === 'location'
      ) {
        // Restore location configs
        return {
          ...defaultGLA,
          option: this.existingLocationGLAConfig
        };
      }

      return defaultGLA;
    });
  }

  @isTruthy
  @Watch('isCourseLevelAttributeTabOpened', { immediate: true })
  onTabChange(isAdminOnGroupLevelAttributeTab: boolean) {
    if (isAdminOnGroupLevelAttributeTab && !this.hasFetchedDefaultValues) {
      // fetch only when admin is on the right tab
      this.getDefaultCourseLevelAttributes();
      this.getRequiredPublicCourseLevelAttributes();
    }
  }

  @Watch('getGroupLevelAttributeTypesApiState', { deep: true })
  onGetGroupLevelAttributeTypesSuccess(state: ApiState) {
    if (state.success) {
      this.availableAttributeTypes = clone(
        this.groupLevelAttributeTypes
      ) as GroupLevelAttributeType[];
    }
  }

  @Watch('getDefaultCourseLevelAttributesApiState')
  onGetDefaultGroupLevelAttributeStateChange(state: ApiState) {
    if (state.success) {
      this.defaultCourseLevelAttributes = this.processDefaultCourseLevelAttributes();
      this.areDefaultAttributesMassaged = true;
      this.hasFetchedDefaultValues = true;

      this.updateParentValue();

      if (this.isSettings) {
        this.getGroupLevelAttributeValuesByGroupId(this.groupId);
      }
    }

    if (state.error) {
      Toast.open({
        message: String(
          (state.error as ApiAxiosError)?.response?.data?.message ?? state.error
        ),
        type: 'is-danger',
        position: 'is-top'
      });
    }
  }

  /**
   * If course is created with modules, the trainer field should be removed from
   * the course level attribute tab. If the radio selection is updated, the array
   * should restore the field to the course level attribute tab. Since the fields
   * are rendered dynamically using the `defaultGroupLevelAttributes` array, this
   * is done to maintain the correct order and reference for the remaining objects
   * in the array.
   */
  @Watch('hasModules')
  onHasModuleSelectionChanged() {
    // Remove trainer attribute from defaultGroupLevelAttributes
    if (this.hasModules) {
      this.removeTrainersGLA();
    } else {
      // Restore the original list with values, except trainers.
      this.restoreTrainersGLA();
    }

    // Trigger update parent array
    this.updateParentValue();
  }

  @Watch('getGroupLevelAttributeValuesByGroupIdApiState', { deep: true })
  onGetGroupLevelAttributeValuesByGroupIdSuccess(state: ApiState) {
    if (state.success) {
      if (this.currentGroupAttributeValues.length === 0) {
        return;
      }

      /**
       * Ensure that the fetched GLA values belong to the current course group.
       * This prevents data collision when multiple components share the same
       * global state (e.g. when creating a new primary organisation).
       */
      if (
        this.isSettings &&
        this.groupId &&
        this.currentGroupAttributeValues[0].group &&
        Number(this.currentGroupAttributeValues[0].group.id) !==
          Number(this.groupId)
      ) {
        return;
      }

      this.selectedCourseAttributeValues = clone(
        this.currentGroupAttributeValues
      );

      this.hasTrainersInGLAs = this.selectedCourseAttributeValues.some(
        (attr) =>
          attr.label.toLowerCase() === this.trainerGLAConfig.label &&
          attr.groupLevelAttributeType.type === this.trainerGLAConfig.type
      );

      /*
       * After fetch success, massage attribute data.
       * isTitle, isDefault are not stored in database.
       * They are only used for UI rendering only.
       */
      this.selectedCourseAttributeValues.forEach(
        (attrVal: GroupLevelAttributeValue) => {
          /* Value from db are by default without any error until validation runs. */
          attrVal.hasFieldError = true;
          attrVal.isTitle = isTitleAttribute(attrVal);
          attrVal.groupLevelAttributeSpec.isDefault = isDefaultCourseGLA(
            attrVal
          );

          // If attribute is default, assign values to optional properties (value, mapId, specId)
          if (isDefaultCourseGLA(attrVal)) {
            const defaultAttributeIndex = this.defaultCourseLevelAttributes.findIndex(
              (defaultAttr) =>
                defaultAttr.groupLevelAttributeType.type ===
                  attrVal.groupLevelAttributeType.type &&
                defaultAttr.label === attrVal.label
            );

            // Assign value, map ID, and spec ID to default GLAs
            if (defaultAttributeIndex > -1) {
              const existingValue = this.defaultCourseLevelAttributes[
                defaultAttributeIndex
              ].value;

              // Only update value if it's equal (sync) to preserve local changes
              // If values are different, assume local changes are newer
              // Exception: On initialization, always overwrite with DB value
              if (
                this.isInitializing ||
                deepEqual(existingValue, attrVal.value)
              ) {
                this.defaultCourseLevelAttributes[defaultAttributeIndex].value =
                  attrVal.value;
              }

              this.defaultCourseLevelAttributes[
                defaultAttributeIndex
              ].mapId = Number(attrVal.mapId);
              this.defaultCourseLevelAttributes[
                defaultAttributeIndex
              ].groupLevelAttributeSpec.id = Number(
                attrVal.groupLevelAttributeSpec.id
              );
            }
          }
        }
      );

      /*
       * When all attribute data massaging is done,
       * push attributes into active array.
       */
      this.selectedCourseAttributeValues.forEach((attribute, index) => {
        if (!isDefaultCourseGLA(attribute)) {
          /**
           * Mark attribute as disabled if it's existing and user has no permission
           * to edit existing attributes.
           *
           * Newly added attributes can still be edited.
           */
          const hideAndDisabledAttribute: boolean =
            'id' in attribute &&
            !this.isUserAllowed(
              PermissionsMatrixActionsEnum.UPDATE,
              'group_administration-groups-update_groups-update_group_attributes-update_existing_attributes',
              true
            );

          // Only add UNIQUE, NEW attributes
          const newAttributeToAdd = {
            ...attribute,
            hasFieldError: true,
            isHidden: hideAndDisabledAttribute,
            isDisabled: hideAndDisabledAttribute
          };

          const attributeExists = this.activeNonDefaultCourseLevelAttributes.some(
            (existingAttr) =>
              Number(existingAttr.id) === Number(newAttributeToAdd.id)
          );

          // If it doesn't exist, push the new attribute.
          if (!attributeExists) {
            this.activeNonDefaultCourseLevelAttributes.push(newAttributeToAdd);
          }
        }
      });

      /**
       * Courses with course modules should not have trainers GLA value, because the association
       * to the trainer is persisted via course modules instead.
       *
       * This method serves as a fallback to check against existing trainers GLA values (if any)
       * in courses with course modules, then mark them for deletion.
       */
      if (this.isSettings && this.hasModules) {
        const existingTrainerIndex: number = this.selectedCourseAttributeValues.findIndex(
          (gla) =>
            gla.groupLevelAttributeType.type === 'trainer' &&
            gla.label === 'Trainers'
        );

        if (existingTrainerIndex !== -1) {
          const existingTrainerGLA: GroupLevelAttributeValue = this
            .selectedCourseAttributeValues[existingTrainerIndex];
          this.markAttributeForDeletion(existingTrainerGLA);
          this.debouncedDeleteGroupLevelAttributeValues([existingTrainerGLA]);
        }
      }

      this.areGroupLevelAttributeValuesMassaged = true;

      this.processCourseSizeGLA();

      this.$nextTick(() => {
        this.isInitializing = false;
      });
    }
  }

  /**
   * Based on course end date and current date, conditionally disable the Course Size GLA.
   * This method should be triggered on two occasions:
   * - On component mount and initial processing on the `defaultCourseLeveLAttributes` array.
   * - Any subsequent updates on the 'End Date' GLA values
   */
  processCourseSizeGLA() {
    const courseEndDateGLAIndex = this.defaultCourseLevelAttributes.findIndex(
      (gla) =>
        gla.label === 'End Date' &&
        gla.groupLevelAttributeType.type === 'datetime'
    );

    const courseSizeGLAIndex = this.defaultCourseLevelAttributes.findIndex(
      (gla) =>
        gla.label === 'Course Size' &&
        gla.groupLevelAttributeType.type === 'integer'
    );

    const currentDate = dayjs().toDate();
    let endDate: Date | null = null;

    if (courseEndDateGLAIndex > -1) {
      endDate = dayjs(
        this.defaultCourseLevelAttributes[courseEndDateGLAIndex].value as string
      ).toDate();
    }

    if (courseSizeGLAIndex > -1 && endDate && currentDate > endDate) {
      this.defaultCourseLevelAttributes.splice(courseSizeGLAIndex, 1, {
        ...this.defaultCourseLevelAttributes[courseSizeGLAIndex],
        // Disable course size GLA if current date exceeds end date
        isDisabled: true
      });
    } else {
      this.defaultCourseLevelAttributes.splice(courseSizeGLAIndex, 1, {
        ...this.defaultCourseLevelAttributes[courseSizeGLAIndex],
        // Otherwise re-enable
        isDisabled: false
      });
    }
  }

  // TODO: Add separate watcher for course members to sync up Course Size GLA disabled state
  // Currently blocked by registrations

  // Separate watcher method for deletion to reset deleteCourseLevelAttribute array
  @Watch('createGroupLevelAttributeValuesApiState', { deep: true })
  mergeExistingMappingsToNewAttributes(state: ApiState) {
    if (state.success) {
      if (this.createdGroupLevelAttributeValues) {
        this.activeNonDefaultCourseLevelAttributes = this.activeNonDefaultCourseLevelAttributes.map(
          (attrToUpdate) => {
            // TODO: Potentially rework to use Map instead for better performance
            const matchingAttribute:
              | AttributeOptionsWithValue
              | undefined = this.createdGroupLevelAttributeValues.find(
              (createdAttr) =>
                createdAttr.groupLevelAttributeId === Number(attrToUpdate.id)
            );

            if (!matchingAttribute) {
              return attrToUpdate;
            }

            attrToUpdate.mapId = matchingAttribute.mapId;
            attrToUpdate.mapStatus = matchingAttribute.status;
            attrToUpdate.groupLevelAttributeSpec.order =
              matchingAttribute.order;
            return attrToUpdate;
          }
        );
      }
    }
  }

  @Watch('createGroupLevelAttributeValuesApiState', { deep: true })
  @Watch('deleteGroupLevelAttributeValuesApiState', { deep: true })
  @Watch('upsertIndividualGroupLevelAttributeValueApiState', { deep: true })
  onAttributeUpdatedOrDeletedApiStateChanged(state: ApiState) {
    if (state.success) {
      Toast.open({
        type: 'is-success',
        position: 'is-top',
        message: 'Changes saved.',
        duration: 2000,
        queue: false
      });

      this.processCourseSizeGLA();
      this.updateDefaultGLAOrdering();
      this.updateOrderingAndParentValue();
    }

    if (state.error) {
      Toast.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message:
          'Something went wrong. Could not update group level attribute values.'
      });
    }
  }

  @Watch('syncedCourseType')
  onCourseTypeUpdated() {
    const clonedDefaultAttributes = deepCopy(this.defaultCourseLevelAttributes);

    const courseTypeGLAConfig = DEFAULT_COURSE_ATTRIBUTES.COURSE_TYPE;

    const courseTypeGLA = clonedDefaultAttributes.find(
      (glav: GroupLevelAttributeValue) => {
        return (
          glav.label.toLowerCase() === courseTypeGLAConfig.label &&
          glav.groupLevelAttributeType.type === courseTypeGLAConfig.type
        );
      }
    );

    if (courseTypeGLA) {
      (courseTypeGLA.value as GroupLevelAttributeListType).selected = this.syncedCourseType.name;
      this.handleUpdateAttributeValue(courseTypeGLA);
    }
  }

  @Emit('update-parent-group')
  returnParentGroup() {
    return this.parentGroup;
  }

  @Emit('update-selected-trainers')
  returnSelectedTrainerIds() {
    return this.selectedTrainerIds;
  }
}
